import React from 'react';

export const TrafficLight = ({ status, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3',
  };

  const statusClasses = {
    green: 'traffic-light-green',
    yellow: 'traffic-light-yellow',
    red: 'traffic-light-red',
    gray: 'traffic-light-gray',
  };

  return (
    <div 
      className={`traffic-light ${sizeClasses[size]} ${statusClasses[status] || statusClasses.gray}`}
      data-testid={`traffic-light-${status}`}
    />
  );
};

export const TrafficLightWithLabel = ({ status, label, size = 'md' }) => {
  const statusLabels = {
    green: 'On Track',
    yellow: 'At Risk',
    red: 'Blocked',
    gray: 'Not Started',
  };

  return (
    <div className="flex items-center gap-2">
      <TrafficLight status={status} size={size} />
      <span className="text-sm text-gray-600">
        {label || statusLabels[status]}
      </span>
    </div>
  );
};

export default TrafficLight;
